import React from 'react';

export function Home() {
    return (
        <div className="p-4">
            <h1 className="mx-auto text-center text-info">Kara Quinn <span className="text-muted">Development</span></h1>
            <p className="my-4">
                Welcome to my portfolio! My name is Kara Quinn and I am a software developer currently based out of Hamilton, Ontario.
                My goal for this website is to discuss my work experience, to showcase projects I enjoyed working on at college, 
                and to give background on myself both professionally and personally.
            </p>
            <p>This site is built using:</p>
            <ul>
                <li key="home-react">
                    <a href="https://facebook.github.io/react/" target="_blank" className="link-dark" rel="noopener noreferrer">React</a> for client-side code
                </li>
                <li key="home-bootstrap">
                    <a href="http://getbootstrap.com/" target="_blank" className="link-dark" rel="noopener noreferrer">Bootstrap</a> for layout and styling
                </li>
                <li key="home-digitalocean">
                    <a href="https://www.digitalocean.com/" target="_blank" className="link-dark" rel="noopener noreferrer">DigitalOcean</a> for web hosting
                </li>
            </ul>
            <p className="my-4">You can find my github repository <a href="https://github.com/KQuinnDevelopment" className="link-dark" target="_blank" rel="noopener noreferrer">here!</a></p>
            <p>
                This is a website that I built myself by hand, keeping it clean and simple with what I hope is a hint of personal flair.
                If anything on this site is unclear, or if you have any questions at all, do not hesitate to contact me on <a href="https://www.linkedin.com/in/karaquinnh/" className="link-dark" target="_blank" rel="noopener noreferrer">LinkedIn</a>.
                Thank you for taking the time to look it over and for considering me as a potential hire.
            </p>
            <p>My name may appear differently, or as my <a href="https://www.dictionary.com/e/pop-culture/deadname/" className="link-dark" target="_blank" rel="noopener noreferrer">deadname</a>, throughout the site.
               That was how I presented myself during college but now that I've graduated, I am determined to be my more authentic self.</p>
        </div>
    );
}